function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "icon-saving");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon-saving",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,10.25 L16,8 L13,11 L16,14 L16,11.75 C18.4825,11.75 20.5,13.7675 20.5,16.25 C20.5,17.0075 20.3125,17.7275 19.975,18.35 L21.07,19.445 C21.655,18.5225 22,17.4275 22,16.25 C22,12.935 19.315,10.25 16,10.25 Z M16,20.75 C13.5175,20.75 11.5,18.7325 11.5,16.25 C11.5,15.4925 11.6875,14.7725 12.025,14.15 L10.93,13.055 C10.345,13.9775 10,15.0725 10,16.25 C10,19.565 12.685,22.25 16,22.25 L16,24.5 L19,21.5 L16,18.5 L16,20.75 Z",
  id: "Shape",
  fill: "#4A4A4A",
  fillRule: "nonzero",
  transform: "translate(16.000000, 16.250000) rotate(0.000000) translate(-16.000000, -16.250000) "
}));

function SvgIconSaving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "7b820c1b10a4b66540a6de20fc9a5902.svg";
export { SvgIconSaving as ReactComponent };